import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MarketdateBooth } from './marketdate-booth.model';
import { MarketdateBoothService } from './marketdate-booth.service';
@Injectable()
export class MarketdateBoothPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private marketdateBoothService: MarketdateBoothService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdateBoothService.find(id).subscribe((marketdateBooth) => {
                this.marketdateBoothModalRef(component, marketdateBooth);
            });
        } else {
            return this.marketdateBoothModalRef(component, new MarketdateBooth());
        }
    }

    marketdateBoothModalRef(component: Component, marketdateBooth: MarketdateBooth): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketdateBooth = marketdateBooth;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth-popup.service.ts